import { useSelector } from 'react-redux';

import { useGetSubscriptionCurrencyCode } from './use-get-subscription-currency-code';
import Global from '../../../../store/global-selectors';
import { getDefaultAnalyticsLicenseAddonPrice } from '../components/manage-subscription-drawer/constants';

export const useAnalyticsLicenseData = () => {
  const subscriptionData = useSelector(Global.selectSellerSubscriptionData);
  const { currentBillingPlan } = subscriptionData ?? {};
  const currencyCode = useGetSubscriptionCurrencyCode();

  const totalLicenseLimit = currentBillingPlan?.analyticsLicenseLimit?.limit ?? 0;
  const additionalLicenses = currentBillingPlan?.additionalAnalyticsLicenses ?? 0;
  const includedLicenses = Math.max(0, totalLicenseLimit - additionalLicenses);

  const defaultPrice = getDefaultAnalyticsLicenseAddonPrice(currentBillingPlan?.billingPlanId);

  const unitCost = {
    value: currentBillingPlan?.analyticsLicenseAddOnPrice?.value ?? defaultPrice,
    code: currentBillingPlan?.analyticsLicenseAddOnPrice?.code ?? currencyCode,
  };

  const additionalLicensesCost = {
    value: additionalLicenses * unitCost.value,
    code: currentBillingPlan?.analyticsLicenseAddOnPrice?.code ?? currencyCode,
  };

  return {
    includedLicenses,
    additionalLicenses,
    totalLicenseLimit,
    unitCost,
    additionalLicensesCost,
  };
};
